<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
import VueAnalitycs from './vue-analytics';

export default {
  name: 'App',
  mixins: [VueAnalitycs],
  mounted() {
    window.$emitter.$on('is-admin', isAdmin => {
      if (!isAdmin) {
        this.analyticAccept();
      } else {
        this.analyticDeny();
      }
    });
  },
};
</script>
<style lang="scss">
@import '@/estilo/sass/estilo.scss';
@import '@/estilo/sass/printer.scss';
@import '~@marcius-studio/vue-notice/static/main.scss';
@import '~@marcius-studio/vue-notice/static/themes/mint.scss';

body {
  font-family: 'OpenSans';
  overflow: overlay;
  overflow-x: hidden;
}

button {
  outline: none;
}

::-webkit-scrollbar {
  width: 14px;
  height: 18px;
}
::-webkit-scrollbar-thumb {
  height: 6px;
  border: 4px solid rgba(0, 0, 0, 0);
  background-clip: padding-box;
  -webkit-border-radius: 7px;
  background-color: rgba(0, 0, 0, 0.15);
  // -webkit-box-shadow: inset -1px -1px 0px rgba(0, 0, 0, 0.05), inset 1px 1px 0px rgba(0, 0, 0, 0.05);
}
::-webkit-scrollbar-button {
  width: 0;
  height: 0;
  display: none;
}
::-webkit-scrollbar-corner {
  background-color: transparent;
}

#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  font-family: 'OpenSans';
  margin: 0 auto;
  background: url(./assets/imgs/pattern.png);

  & a {
    cursor: pointer !important;
  }

  & ul {
    list-style-type: none;
    text-align: left;
  }

  button {
    cursor: pointer;
    user-select: none;
  }
}
</style>
